import type { LibraryOptions } from '@aws-amplify/core';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sessionStorage } from 'aws-amplify/utils';

import type { AmplifyConfiguration } from '@/amplifyconfiguration';
import configJson from '@/amplifyconfiguration.json';

export const initAmplify = (options: LibraryOptions | undefined = undefined) => {
  // Deep copy to avoid mutation of the original config
  const config: AmplifyConfiguration = JSON.parse(JSON.stringify(configJson)) as AmplifyConfiguration;

  // Update the existing driverApi endpoint (v1)
  const driverApiConfig = config.aws_cloud_logic_custom.find((api) => api.name === 'driverApi');
  if (driverApiConfig) {
    driverApiConfig.endpoint = import.meta.env.VITE_DRIVER_API_ENDPOINT;
  }

  // Add driverApiV2 configuration
  config.aws_cloud_logic_custom.push({
    name: 'driverApiV2',
    region: config.aws_project_region,
    endpoint: `${import.meta.env.VITE_API_ENDPOINT}/v2/driver`,
  });

  // Update GraphQL endpoint
  config.aws_appsync_graphqlEndpoint = import.meta.env.VITE_GRAPHQL_ENDPOINT;

  Amplify.configure(config, options);
  cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);
};
